import React, { Component } from 'react';
import RevenueVisit from './RevenueVisit';
import ContractPlan from './ContractPlan';
import './style.less';

class RevenueVisitAndContractPlan extends Component {
    state = {
        cur: 'revenueVisit',
    }

    handleBtnClick = (cur) => {
        this.setState({ cur });
    }

    render() {
        const { cur } = this.state;
        //const{exportable}=this.props;
        const exportable = true;
        return (
            <div className="content">
                <div className="main">
                <div className="reportTitle">{this.props.title}</div>
                    <div className="main-content">
                        <div className="tab_flex">
                            <a onClick={() => this.handleBtnClick('revenueVisit')} className={cur == 'revenueVisit' ? 'curr' : ''} >
                                收入访视报告
                            </a>
                            <a onClick={() => this.handleBtnClick('contractPlan')} className={cur == 'contractPlan' ? 'curr' : ''} >
                                合同计划访视报告
                            </a>
                        </div>
                        { cur === 'revenueVisit' && <RevenueVisit exportable={exportable}/> }
                        { cur === 'contractPlan' && <ContractPlan exportable={exportable}/> }
                    </div>
                </div>
            </div>
        )
    }
}

export default RevenueVisitAndContractPlan;



// WEBPACK FOOTER //
// ./src/components/homePage/revenueVisitAndContractPlan/index.js